<div class="sucursal-container">
  <div class="title-and-button">
    <button
      *ngIf="!loggedUser?.isResponsible"
      (click)="goToAgregarUsuario(false)"
      mat-raised-button
      [disabled]="loading"
      class="button-add"
    >
      + Agregar responsable
    </button>
  </div>
</div>

<div class="search-branch">
  <mat-form-field class="input-yaca w-100">
    <mat-label>Buscar responsable</mat-label>
    <input matInput [formControl]="searchResp" autocomplete="off" type="text" placeholder="Buscar responsable" />
  </mat-form-field>
</div>

<div *ngIf="loading" style="width: 100%; display: flex; justify-content: center">
  <img style="border-radius: 57px" src="assets/icons/logo-fiser-loading.gif" alt="" width="150px" />
</div>

<div *ngIf="!loading">
  <div class="cont-padre-sucursales">
    <div
      class="contenedor-de-sucursales"
      *ngFor="let resp of filterResp | paginate : { id: 'respActual', itemsPerPage: 4, currentPage: respActual }"
    >
      <div class="sucursales">
        <div class="sucursal-nombre" (click)="editClickEventHandler(resp)">
          <span>{{ resp.nombre + ' ' + resp.apellido }}</span
          ><br />
          <div class="sucursal-direccion">
            Código: {{ resp.usuarioId }} - Estado: {{ evaluarEstado(resp.estado) }} -
            <span>Rol: {{ RolesWeb[resp.rol] }}</span>
          </div>
        </div>
        <div class="d-inline-flex" *ngIf="!loggedUser?.isResponsible">
          <button
            mat-icon-button
            class="d-flex align-items-center justify-content-center m-0"
            (click)="editClickEventHandler(resp)"
          >
            <mat-icon class="mat-icon-primary">edit</mat-icon>
          </button>
          <button
            mat-icon-button
            class="d-flex align-items-center justify-content-center m-0"
            (click)="removeClickEventHandler(resp)"
          >
            <mat-icon class="mat-icon-primary">delete</mat-icon>
          </button>
        </div>
      </div>
    </div>
    <pagination-controls
      *ngIf="responsiblesList?.length !== 0"
      id="respActual"
      class="my-pagination"
      maxSize="7"
      previousLabel=""
      nextLabel=""
      (pageChange)="respActual = $event"
    ></pagination-controls>
  </div>
</div>
